import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=3768b534&scoped=true&lang=pug&"
import script from "./setting.vue?vue&type=script&lang=ts&"
export * from "./setting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3768b534",
  null
  
)

export default component.exports